import Header from '../../components/Header';
import Privacy from './components/Privacy.js';

const PrivacyPolicy = () => {
  return (
    <>
      <div className='page-bg'>
        <Header />
        <Privacy />
      </div>
    </>
  );
};

export default PrivacyPolicy;
